import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/hypseya-brand.css";
import App from "@/App";
import { Auth0Provider } from "@auth0/auth0-react";
import { MockAuth0Provider } from "@/MockAuth0Provider";

const DEV_BYPASS_AUTH = process.env.REACT_APP_DEV_BYPASS_AUTH === 'true';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const redirectUri = process.env.REACT_APP_AUTH0_REDIRECT_URI || `${window.location.origin}/callback`;

const root = ReactDOM.createRoot(document.getElementById("root"));

if (DEV_BYPASS_AUTH) {
  root.render(
    <React.StrictMode>
      <MockAuth0Provider>
        <App />
      </MockAuth0Provider>
    </React.StrictMode>
  );
} else {
  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: redirectUri,
          audience: audience,
          scope: "openid profile email"
        }}
        useRefreshTokens={true}
        cacheLocation="localstorage"
      >
        <App />
      </Auth0Provider>
    </React.StrictMode>
  );
}
